import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Stack,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface SearchFilters {
  query: string;
  status: string;
  category: string;
  dateFrom: string;
  dateTo: string;
}

const SearchPage: React.FC = () => {
  const [filters, setFilters] = useState<SearchFilters>({
    query: '',
    status: '',
    category: '',
    dateFrom: '',
    dateTo: '',
  });

  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field: keyof SearchFilters) => (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent
  ) => {
    setFilters(prev => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      // TODO: API呼び出しを実装
      console.log('検索実行:', filters);
      // const response = await searchAPI(filters);
      // setResults(response.data);
      setResults([]); // 仮のデータ
    } catch (error) {
      console.error('検索エラー:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    setFilters({
      query: '',
      status: '',
      category: '',
      dateFrom: '',
      dateTo: '',
    });
    setResults([]);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        落とし物検索
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            label="キーワード検索"
            placeholder="アイテム名、説明、場所で検索..."
            value={filters.query}
            onChange={handleInputChange('query')}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
            }}
          />

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <FormControl sx={{ minWidth: 120, flex: 1 }}>
              <InputLabel>ステータス</InputLabel>
              <Select
                value={filters.status}
                label="ステータス"
                onChange={handleInputChange('status')}
              >
                <MenuItem value="">すべて</MenuItem>
                <MenuItem value="Found">未引き取り</MenuItem>
                                  <MenuItem value="Claimed">引き取り済み</MenuItem>
                                  <MenuItem value="Returned">返却完了</MenuItem>
                                  <MenuItem value="Disposed">処分済み</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120, flex: 1 }}>
              <InputLabel>カテゴリ</InputLabel>
              <Select
                value={filters.category}
                label="カテゴリ"
                onChange={handleInputChange('category')}
              >
                <MenuItem value="">すべて</MenuItem>
                <MenuItem value="electronics">電子機器</MenuItem>
                <MenuItem value="accessories">アクセサリー</MenuItem>
                <MenuItem value="clothing">衣類</MenuItem>
                <MenuItem value="bags">バッグ・カバン</MenuItem>
                <MenuItem value="documents">書類・証明書</MenuItem>
                <MenuItem value="other">その他</MenuItem>
              </Select>
            </FormControl>

            <TextField
              type="date"
              label="発見日（開始）"
              value={filters.dateFrom}
              onChange={handleInputChange('dateFrom')}
              sx={{ flex: 1 }}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              type="date"
              label="発見日（終了）"
              value={filters.dateTo}
              onChange={handleInputChange('dateTo')}
              sx={{ flex: 1 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              onClick={handleSearch}
              disabled={loading}
              startIcon={<SearchIcon />}
            >
              検索
            </Button>
            <Button
              variant="outlined"
              onClick={handleClearFilters}
            >
              フィルターをクリア
            </Button>
          </Box>
        </Stack>
      </Paper>

      {/* 検索結果表示エリア */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          検索結果
        </Typography>
        
        {results.length > 0 ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            {results.map((item, index) => (
              <Paper key={index} sx={{ p: 2, minWidth: 280, flex: '1 1 300px' }}>
                <Typography variant="subtitle1">{item.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
                <Box sx={{ mt: 1 }}>
                  <Chip label={item.status} size="small" />
                </Box>
              </Paper>
            ))}
          </Box>
        ) : (
          <Typography color="text.secondary">
            検索条件を入力して検索してください
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default SearchPage;